import React, { useContext, useEffect, useState } from "react";
import { RiSearch2Fill } from "react-icons/ri";
import Form from "react-bootstrap/Form";
import { GoArrowRight } from "react-icons/go";
import dummyComapyLogo from "../../../assets/dummyProfileImage.png";
import { FaLocationDot } from "react-icons/fa6";
import { EventButton, PaginationBtn } from "../../component/ReUseComps/Button";
import cashMultiple from "../../../assets/cash-multiple.png";
import bagSolid from "../../../assets/bag-solid.png";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { URLS } from "../../../Utils/App_urls";
import UserContext from "../../component/ContextApi/UserContext";
import { Oval } from "react-loader-spinner";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import "../ApplyJob/JobCards/JobCards.css";
import "../AppliedJob/AppliedJob.css";
import { getJobPostedDate } from "../../../Company/Component/CustomHook/jobPostedDate";
import { IoSearch } from "react-icons/io5";
import Pagination from "../../component/Pagination";

export default function JobCards() {
  const { setSingleAppliedJobDetails, singleAppliedJobDetails } =
    useContext(UserContext);
  const navigate = useNavigate();
  const [appliedJobDetails, setAppliedJobDetails] = useState([]);
  const [filterJobsArr, setFilterJobsArr] = useState([]);
  const [jobTitle, setJobTitle] = useState("");
  const [jobLocation, setJobLocation] = useState("");
  const [getJobLoader, setGetJobLoader] = useState(false);
  const [totalPage, setTotalPage] = useState(1);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getAllJobs = (pageNo = 1) => {
    setGetJobLoader(true);
    axios
      .get(`${URLS.getSaveLater}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        params: {
          page: pageNo,
          limit: 10,
        },
      })
      .then((res) => {
        setAppliedJobDetails(res?.data?.savedJobs);
        setFilterJobsArr(res?.data?.savedJobs);
        setSingleAppliedJobDetails(res?.data?.savedJobs);
        setTotalPage(res?.data?.totalPages);
        setGetJobLoader(false);

        setTotalPages(res?.data?.totalPages);
        setCurrentPage(res?.data?.currentPage);
      })
      .catch((err) => {
        setGetJobLoader(false);
      });
  };

  const redirectTojobDetails = (job, id) => {
    navigate(`/user/savedJobs/job-details/${id}`, {
      state: { DATA: id },
    });
    setSingleAppliedJobDetails(job);
  };

  const handleFilterAppliedJob = (e) => {
    let enterTitle = e.target.value;
    setJobTitle(enterTitle);
  };

  useEffect(() => {
    getAllJobs(currentPage);
  }, [currentPage]);

  const filterJob = appliedJobDetails?.filter((data) => {
    console.log(data);
    return data?.jobDetails[0]?.title
      ?.toLowerCase()
      .includes(jobTitle.toLowerCase());
  });

  return (
    <>
      <div className="job-card-container applied_job_cards_contaner pb-0">
        <div className="appliedJobStatus d-flex align-items-center justify-content-between flex-wrap mb-3">
          <p>
            Saved{" "}
            <span className="totaldataspan">{appliedJobDetails?.length}</span>{" "}
            Jobs
          </p>
          <div className="serch-job-input d-flex align-items-center justify-content-between">
            <IoSearch fontSize={20} />
            <Form.Control
              placeholder="Job Title"
              aria-label="Job Title"
              aria-describedby="basic-addon1"
              onChange={(e) => handleFilterAppliedJob(e)}
              value={jobTitle}
            />
          </div>
        </div>
        <div>
          {filterJob?.length > 0 ? (
            filterJob?.map((job, index) => (
              <div
                className="job-search-body cards_shadow mb-3"
                // onClick={() => redirectTojobDetails(job, job?.JobId)}
                key={index}
              >
                <div
                  className={`job-cards d-flex  active-box-bdr ${
                    job?._id === singleAppliedJobDetails?._id &&
                    "active-box-desig"
                  }`}
                >
                  <div className="job-right-container d-flex flex-column px-0 gap-1 flex-grow-1">
                    <div className="job-card-header d-flex align-items-start justify-content-between flex-wrap gap-2">
                      <div className="company-title d-flex align-items-start gap-1">
                        <div className="company-logo-container">
                          <img
                            className="company-logo-img"
                            src={
                              job?.companyDetails?.[0]?.companylogo ||
                              dummyComapyLogo
                            }
                            alt={job?.company}
                          />
                        </div>

                        <div className="compay-name">
                          <h1 className="m-0">{job?.jobDetails[0]?.title}</h1>
                          <p className="m-0">
                            {job?.companyDetails?.[0]?.companyName || "N/A"}
                          </p>
                        </div>
                      </div>
                      <span className="post-date created_time">
                        {getJobPostedDate(job?.createdAt?.split("T"))}
                      </span>
                    </div>
                    <div className="job-conadtion-box">
                      <div>
                        <img src={bagSolid} alt="bag solid" />{" "}
                        <span>{job?.jobDetails[0]?.experience}</span>
                      </div>
                      {job?.jobDetails[0]?.salaryType === "Fixed Salary" && (
                        <div>
                          <img src={cashMultiple} alt="cash multiple" />{" "}
                          <span>{job?.jobDetails[0]?.FixedSalary}</span>
                        </div>
                      )}
                      {job?.jobDetails[0]?.salaryType === "Salary Range" && (
                        <div>
                          <img src={cashMultiple} alt="cash multiple" />{" "}
                          <span>
                            {job?.jobDetails[0]?.minSalary} -{" "}
                            {job?.jobDetails[0]?.maxSalary}
                          </span>
                        </div>
                      )}
                      {job?.jobDetails[0]?.salaryType === "Not Disclose" && (
                        <div>
                          <img src={cashMultiple} alt="cash multiple" />{" "}
                          <span>{job?.jobDetails[0]?.salaryType}</span>
                        </div>
                      )}
                      <div>
                        <FaLocationDot size={16} />{" "}
                        <span>{job?.jobDetails[0]?.workPlace}</span>
                      </div>
                    </div>

                    <div className="job-preferences d-flex gap-1 gap-sm-2 flex-wrap">
                      <span key={index}>
                        {job?.jobDetails[0]?.deparmentType}
                      </span>
                      <span key={index}>{job?.jobDetails[0]?.workPlace}</span>
                      <span key={index}>{job?.jobDetails[0]?.shift}</span>
                    </div>

                    <div className="job-desp-inCard skill_type job_description">
                      {job?.jobDetails[0]?.jobSummary?.slice(0, 550)}
                      {job?.jobDetails[0]?.jobSummary?.length > 600 && "..."}
                      {/* <div dangerouslySetInnerHTML={{ __html: convertHtmlToText(job?.jobDescription).slice(0, 300) + '...' }} /> */}
                    </div>
                    <div className="company-req-skills skill_type d-flex flex-wrap gap-2 gap-sm-3">
                      {job?.jobDetails[0]?.skills
                        ?.slice(0, 3)
                        ?.map((skill, index) => (
                          <span key={index}>{skill}</span>
                        ))}
                      {job?.jobDetails[0]?.skills?.length > 3 && (
                        <span>
                          {job?.jobDetails[0]?.skills?.length - 3}+ more
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="cards-btn-box flex-row flex-sm-column flex-wrap">
                    <button
                      className={`job-search-btn`}
                      // onClick={() => redirectTojobDetails(job)}
                      onClick={() => redirectTojobDetails(job, job?.JobId)}
                    >
                      View <GoArrowRight fontSize={20} />
                    </button>
                    {/* <div className={`job_staus_btn_saved job_staus_rejected_btn_saved ${index % 2 === 0 && 'd-none'}`}>Rejected</div>
                  <div className={`job_staus_btn_saved job_staus_shortlisted_btn_saved ${index % 2 != 0 && 'd-none'}`}>Shortlisted</div>
                  <div className="job_staus_btn_saved job_staus_hired_btn_saved d-none">Hired</div> */}
                    {/* <button className='job-search-outline-btn'>Not Interested</button> */}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <>
              <p>No Job Applied</p>
            </>
          )}

          {/* {appliedJobDetails?.length > 0 && <div className="footer-pagination d-flex align-items-center flex-wrap justify-content-center gap-2 pb-3">
              <p className='vailable-job-para page-table-typo'>Page No. {clipArrLength?.max / 10} / {totalPage}</p>
              <div className='d-flex align-items-center gap-2'>
                  <PaginationBtn style={{ width: 'fit-content' }} className='pagination-btn edgePageBtn'
                      onClick={handleDecPagination}
                      disabled={paginationBtnArr[0] === 1}
                  >
                      <FaAngleLeft fontSize={20} />
                      Previous
                  </PaginationBtn>
                  {
                      paginationBtnArr.map((data, idx) => (
                          <PaginationBtn
                              className={`pagination-btn ${clipArrLength?.max / 10 === data && 'activePageBtn'}`}
                              onClick={() => handlePaginationSize(data)}
                              // disabled={Math.ceil(data > Math.ceil(appliedJobDetails?.length / 10))}>
                              disabled={totalPage < idx + 1}>
                              {data}
                          </PaginationBtn>
                      ))
                  }
                  <PaginationBtn className={`pagination-btn ${appliedJobDetails?.length <= 60 && 'd-none'}`} disabled>...</PaginationBtn>
                  <PaginationBtn
                      style={{ width: 'fit-content' }}
                      className='pagination-btn edgePageBtn'
                      onClick={handleIncPagination}
                      // disabled={appliedJobDetails?.length < (paginationBtnArr[paginationBtnArr?.length - 1] * 10)}
                      disabled={paginationBtnArr[4] >= totalPage}
                  >
                      Next
                      <FaAngleRight fontSize={20} />
                  </PaginationBtn>
              </div>

          </div>} */}

          {appliedJobDetails?.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          )}

          {getJobLoader && (
            <div className="oval_container">
              <Oval width="50" height="50px" color="#3284FF" />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
